import { Component, computed, input } from '@angular/core';
import { ClassValue } from 'clsx';
import { bui } from '../utils/bui';

@Component({
  selector: 'sidebar-badge',
  exportAs: 'sidebarBadge',
  host: {
    '[class]': 'computedClass()',
  },
  template: `<ng-content />`,
})
export class SidebarBadge {
  // Inputs / Outputs
  readonly userClass = input<ClassValue>('', { alias: 'class' });

  // State
  protected readonly computedClass = computed(() =>
    bui(
      // Base
      'group/sidebar-badge',
      'pointer-events-none flex items-center justify-center rounded',
      'px-1 py-0.5',
      'text-xs font-medium tabular-nums',
      'bg-neutral-a3',

      // User classes
      this.userClass(),
    ),
  );
}
